import en from './en';
import ja from './ja';

// Key for accessing local storage
export const BaseLocaleKey = '@sadl-locale';

// Locale consumed by components
export type LocaleObject = typeof en;

// Locale for routes
export type LocaleRoutes = typeof en.Routes;

const locale = {
  English: en,
  Japanese: ja,
};

// Locales that the user can select from
export type Locales = keyof typeof locale;

export default locale;
